import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {Fab} from "@mui/material";
import DownloadIcon from "@mui/icons-material/FileDownload";
import {Description, DescriptionList, DescriptionTerm} from "../parts/Description.parts";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

export default function DownloadBudgetDialog(props) {
  const { classes, confirmationHandler } = props;
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('REPORT_PERIOD_TWO');
  let year = new Date().getFullYear();
  const [fromDate, setFromDate] = useState(`${year}-01-01`);
  const [toDate, setToDate] = useState(`${year}-12-31`);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose =  () => {
    setOpen(false);
    setType('REPORT_PERIOD_TWO');
    setFromDate(`${year}-01-01`);
    setToDate(`${year}-12-31`);
  };

  const handleConfirm = () => {
    switch (type) {
      case 'REPORT_PERIOD_ONE':
        confirmationHandler('2023-05-01', '2024-04-30', type);
        break;
      case 'REPORT_PERIOD_TWO':
        confirmationHandler('2024-05-01', '2025-04-30', type);
        break;
      case 'REPORT_PERIOD_THREE':
        confirmationHandler('2025-05-01', '2026-04-30', type);
        break;
      case 'REPORT_PERIOD_FOUR':
        confirmationHandler('2026-05-01', '2027-04-30', type);
        break;
      case 'CUSTOM_PERIOD':
      case 'YEARLY_BUDGET':
        confirmationHandler(fromDate, toDate, type);
    }

    handleClose();
  };

  const reportTypeOptions = [
    { id: 2, type: 'REPORT_PERIOD_ONE', name: 'Report Period 1 (05/23 - 04/24)' },
    { id: 2, type: 'REPORT_PERIOD_TWO', name: 'Report Period 2 (05/24 - 04/25)' },
    { id: 2, type: 'REPORT_PERIOD_THREE', name: 'Report Period 3 (05/25 - 04/26)' },
    { id: 2, type: 'REPORT_PERIOD_FOUR', name: 'Report Period 4 (05/26 - 04/27)' },
    { id: 3, type: 'CUSTOM_PERIOD', name: 'Custom period' },
  ];

  return (
      <div>
        <Fab
            variant="extended"
            size="medium"
            color="secondary"
            aria-label="add"
            onClick={handleClickOpen}
            className={classes.fab}
            style={{position: 'fixed', marginRight: 200}}
        >
          <DownloadIcon sx={{ fontSize: 24 }}/>
          Report
        </Fab>
        <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Select budget to download</DialogTitle>
          <DialogContent>
            <DescriptionList>
              <DescriptionTerm>Report Type</DescriptionTerm>
              <Description>
                <Select
                    labelId="report-type-select"
                    id="report-type-select"
                    value={type}
                    variant="outlined"
                    onChange={
                      (event) => {
                        setType(event.target.value);
                      }
                    }
                >
                  {reportTypeOptions.length > 0 && reportTypeOptions.map((p) => (
                      <MenuItem key={p.id} value={p.type}>{p.name}</MenuItem>
                  ))}
                </Select>
              </Description>
            </DescriptionList>
            { type === 'CUSTOM_PERIOD' &&
              <>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                    id="fromDate"
                    label="From date"
                    type="date"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                    variant="outlined"
                />
                <TextField
                    sx={{ ml: 5 }}
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                    id="toDate"
                    label="To date"
                    type="date"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                    variant="outlined"
                />
              </>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="primary">
              Download
            </Button>
          </DialogActions>
        </Dialog>
      </div>
  );
}